import React, { forwardRef } from "react";

import TextareaField from "../field-textarea/FieldTextarea.jsx";
import TextField from "../field-text/FieldText.jsx";
import CheckboxField from "../field-checkbox/FieldCheckbox.jsx";
import RadioField from "../field-radio/FieldRadio.jsx";

const Field = forwardRef((props, ref) => {
  let { type, name, value, data, errors = {}, ...rest } = props;

  if (data && data[name] !== undefined) {
    value = data[name];
  }

  errors = errors[name];

  if (type === "checkbox") {
    return (
      <CheckboxField
        type={type}
        name={name}
        value={value}
        errors={errors}
        {...rest}
      />
    );
  }

  if (type === "radio") {
    return (
      <RadioField
        type={type}
        name={name}
        value={value}
        errors={errors}
        {...rest}
      />
    );
  }

  if (type === "textarea") {
    return (
      <TextareaField
        type={type}
        name={name}
        value={value}
        errors={errors}
        {...rest}
      />
    );
  }

  return (
    <TextField
      type={type}
      name={name}
      value={value}
      errors={errors}
      inputRef={ref}
      {...rest}
    />
  );
});
export default Field;
